import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import FormDialog from './FormDialog';
import FormikTextField from './FormikTextField';
import { DomainSchema } from './validation';
import ActionButton from '../buttons/ActionButton';
import SubmitButton from '../buttons/SubmitButton';
import { useTransferDomain } from '../../hooks/domains';
import { PrimaryCheckboxInput } from '../CheckboxMenu';

const initialValues = {
  autoSetting: true,
  domainName: ''
};

const DomainTransferForm = ({ currentProject, open, handleClose }) => {
  const domainTransferMutation = useTransferDomain();
  const resolvedInitialValues = {
    ...initialValues
  };
  const [CheckboxData, setCheckboxDataState] = useState(true);
  initialValues.autoSetting = CheckboxData;

  const handleSubmit = (value, action) => {
    const options = {
      onError: handleClose,
      onSuccess: () => {
        action.resetForm();
        handleClose();
      }
    };
    domainTransferMutation.mutate({ domain: value, projectId: currentProject }, options);
  };

  return (
    <FormDialog fullWidth onClose={handleClose} open={open}>
      <DialogTitle>Transfer Domain</DialogTitle>
      <Formik
        initialValues={resolvedInitialValues}
        onSubmit={handleSubmit}
        validationSchema={DomainSchema}
      >
        {({ isSubmitting, dirty, isValid }) => (
          <Form>
            <DialogContent>
              <DialogContentText>Please enter domain name </DialogContentText>
              <FormikTextField autoFocus label="Domain Name" name="domainName" required />
              <PrimaryCheckboxInput
                CheckboxData={CheckboxData}
                label="Generate 'A' DNS record automatically"
                setCheckBox={setCheckboxDataState}
              />
            </DialogContent>
            <DialogActions>
              <ActionButton onClick={handleClose} version="secondary">
                Cancel
              </ActionButton>
              <SubmitButton
                disabled={!isValid || !dirty}
                isLoading={isSubmitting}
                version="primary"
              >
                Transfer
              </SubmitButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </FormDialog>
  );
};

export default DomainTransferForm;
